/**
 * NOTICE OF LICENSE.
 *
 * This source file is subject to a commercial license from SASU WEB FUSION AGENCY
 * Use, copy, modification or distribution of this source file without written
 * license agreement from the SASU WEB FUSION AGENCY is strictly forbidden.
 * In order to obtain a license, please contact us: contact@web-fusion.fr
 *
 * @author SASU WEB FUSION AGENCY
 * @copyright Copyright (c) 2024 - SASU WEB FUSION AGENCY
 * @license   Commercial license
 *
 * @version 1.7.6
 */

document.addEventListener('DOMContentLoaded', function () {
  const root = document.getElementById('wfa-oracle-front');
  if (!root) {
    return;
  }

  const grid = document.getElementById('oracle-cards-grid');
  const cards = Array.from(root.querySelectorAll('.wfa-oracle-card'));
  const overlay = document.getElementById('oracle-detail-panel');
  const title = document.getElementById('oracle-detail-title');
  const description = document.getElementById('oracle-detail-description');
  const link = document.getElementById('oracle-detail-link');
  const resetButton = document.getElementById('oracle-reset-selection');
  const closeButton = document.getElementById('oracle-close-detail');
  const shouldShuffleOnReset = (root.dataset.randomOrder || '0') === '1';
  const openedCards = new Set();
  let activeCard = null;

  function getCardIndex(card) {
    return cards.indexOf(card);
  }

  function getCardDebugState(card) {
    if (!card) {
      return null;
    }

    const inner = card.querySelector('.wfa-oracle-card__inner');

    return {
      index: getCardIndex(card),
      title: card.dataset.title || '',
      openedDataset: card.dataset.opened || '0',
      className: card.className,
      innerClassName: inner ? inner.className : '',
      ariaPressed: card.getAttribute('aria-pressed'),
      inlineTransform: inner ? inner.style.transform : '',
      computedTransform: inner ? window.getComputedStyle(inner).transform : ''
    };
  }

  function logOracle(eventName, payload) {
    console.log('[WFA Oracle]', eventName, payload);
  }

  function getCurrentOrder() {
    if (!grid) {
      return [];
    }

    return Array.from(grid.children);
  }

  function clearSelectedCards() {
    cards.forEach(function (card) {
      card.classList.remove('is-selected');
    });
  }

  function setCardVisualState(card, opened) {
    if (!card) {
      return;
    }

    const inner = card.querySelector('.wfa-oracle-card__inner');
    if (!inner) {
      return;
    }

    if (opened) {
      inner.style.setProperty('transform', 'rotateY(180deg)', 'important');
      return;
    }

    inner.style.removeProperty('transform');
  }

  function syncOpenedCards() {
    cards.forEach(function (card) {
      if (openedCards.has(card) || card.dataset.opened === '1') {
        card.dataset.opened = '1';
        card.classList.add('is-opened');
        card.classList.add('is-revealed');
        card.setAttribute('aria-pressed', 'true');
        const inner = card.querySelector('.wfa-oracle-card__inner');
        if (inner) {
          inner.classList.add('is-force-open');
        }
        setCardVisualState(card, true);
      }
    });

    logOracle('syncOpenedCards', Array.from(openedCards).map(getCardDebugState));
  }

  function persistOpenedCard(card) {
    if (!card) {
      return;
    }

    markCardOpened(card);
    card.classList.add('is-static-open');
    const inner = card.querySelector('.wfa-oracle-card__inner');
    const backFace = card.querySelector('.wfa-oracle-card__face--back');
    const frontFace = card.querySelector('.wfa-oracle-card__face--front');

    if (inner) {
      inner.style.setProperty('transform', 'rotateY(180deg)', 'important');
    }

    if (backFace) {
      backFace.style.setProperty('opacity', '0', 'important');
      backFace.style.setProperty('visibility', 'hidden', 'important');
      backFace.style.setProperty('pointer-events', 'none', 'important');
    }

    if (frontFace) {
      frontFace.style.setProperty('transform', 'rotateY(180deg)', 'important');
      frontFace.style.setProperty('opacity', '1', 'important');
      frontFace.style.setProperty('visibility', 'visible', 'important');
      frontFace.style.setProperty('backface-visibility', 'visible', 'important');
      frontFace.style.setProperty('z-index', '2', 'important');
    }

    logOracle('persistOpenedCard', getCardDebugState(card));
  }

  function resetCardState(card) {
    if (!card) {
      return;
    }

    const inner = card.querySelector('.wfa-oracle-card__inner');
    const backFace = card.querySelector('.wfa-oracle-card__face--back');
    const frontFace = card.querySelector('.wfa-oracle-card__face--front');

    card.dataset.opened = '0';
    card.classList.remove('is-opened', 'is-revealed', 'is-selected', 'is-static-open');
    card.removeAttribute('aria-pressed');

    if (inner) {
      inner.classList.remove('is-force-open');
      inner.style.removeProperty('transform');
    }

    if (backFace) {
      backFace.style.removeProperty('opacity');
      backFace.style.removeProperty('visibility');
      backFace.style.removeProperty('pointer-events');
    }

    if (frontFace) {
      frontFace.style.removeProperty('transform');
      frontFace.style.removeProperty('opacity');
      frontFace.style.removeProperty('visibility');
      frontFace.style.removeProperty('backface-visibility');
      frontFace.style.removeProperty('z-index');
    }

    setCardVisualState(card, false);
  }

  function resetAllCards() {
    openedCards.clear();
    cards.forEach(resetCardState);
    clearSelectedCards();
    activeCard = null;
    logOracle('resetAllCards', cards.map(getCardDebugState));
  }

  function markCardOpened(card) {
    if (!card) {
      return;
    }

    openedCards.add(card);
    card.dataset.opened = '1';
    card.classList.add('is-opened');
    card.classList.add('is-revealed');
    card.setAttribute('aria-pressed', 'true');
    const inner = card.querySelector('.wfa-oracle-card__inner');
    if (inner) {
      inner.classList.add('is-force-open');
    }
    setCardVisualState(card, true);
    logOracle('markCardOpened', getCardDebugState(card));
  }

  function closeOverlay(preserveCardState) {
    const closingCard = activeCard;

    logOracle('closeOverlay:start', {
      preserveCardState: preserveCardState,
      activeCard: getCardDebugState(closingCard)
    });

    if (preserveCardState) {
      persistOpenedCard(closingCard);
    } else if (closingCard) {
      openedCards.delete(closingCard);
      resetCardState(closingCard);
    }

    clearSelectedCards();
    activeCard = null;

    if (overlay) {
      overlay.classList.remove('is-visible');
    }

    syncOpenedCards();
    window.requestAnimationFrame(syncOpenedCards);
    window.setTimeout(syncOpenedCards, 60);

    logOracle('closeOverlay:end', {
      activeCard: getCardDebugState(activeCard),
      openedCards: Array.from(openedCards).map(getCardDebugState)
    });
  }

  function shuffleCards() {
    if (!grid || cards.length <= 1) {
      return;
    }

    const currentOrder = getCurrentOrder();
    const minimumMovedCards = Math.min(
      cards.length,
      cards.length <= 3 ? cards.length - 1 : Math.ceil(cards.length / 2)
    );
    let shuffledCards = currentOrder.slice();
    let movedCards = 0;
    let attempts = 0;

    while (attempts < 12 && movedCards < minimumMovedCards) {
      shuffledCards = currentOrder.slice();

      for (let index = shuffledCards.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        const temp = shuffledCards[index];
        shuffledCards[index] = shuffledCards[randomIndex];
        shuffledCards[randomIndex] = temp;
      }

      movedCards = shuffledCards.reduce(function (count, card, index) {
        return count + (card !== currentOrder[index] ? 1 : 0);
      }, 0);

      attempts += 1;
    }

    shuffledCards.forEach(function (card) {
      grid.appendChild(card);
    });
  }

  function selectCard(card) {
    logOracle('selectCard:start', getCardDebugState(card));
    activeCard = card;
    card.classList.remove('is-static-open');
    markCardOpened(card);
    syncOpenedCards();
    clearSelectedCards();
    card.classList.add('is-selected');

    if (title) {
      title.textContent = card.dataset.title || '';
    }

    if (description) {
      const text = card.dataset.description || '';
      description.innerHTML = '';

      if (text) {
        text.split(/\n+/).forEach(function (paragraph) {
          const content = paragraph.trim();
          if (!content) {
            return;
          }

          const p = document.createElement('p');
          p.textContent = content;
          description.appendChild(p);
        });
      }
    }

    if (link) {
      link.href = card.dataset.url || '#';
    }

    if (overlay) {
      overlay.classList.add('is-visible');
    }

    logOracle('selectCard:end', {
      activeCard: getCardDebugState(activeCard),
      openedCards: Array.from(openedCards).map(getCardDebugState)
    });
  }

  cards.forEach(function (card) {
    const frontCta = card.querySelector('.wfa-oracle-card__front-cta');

    card.addEventListener('click', function () {
      logOracle('cardClick', getCardDebugState(card));
      selectCard(card);
    });

    if (frontCta) {
      frontCta.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        const targetUrl = card.dataset.url || '';
        if (!targetUrl || targetUrl === '#') {
          return;
        }

        window.open(targetUrl, '_blank', 'noopener,noreferrer');
      });

      frontCta.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        const targetUrl = card.dataset.url || '';
        if (!targetUrl || targetUrl === '#') {
          return;
        }

        window.open(targetUrl, '_blank', 'noopener,noreferrer');
      });
    }

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          logOracle('cardMutation', {
            attributeName: mutation.attributeName,
            state: getCardDebugState(card)
          });
        }
      });
    });

    observer.observe(card, {
      attributes: true,
      attributeFilter: ['class', 'data-opened', 'aria-pressed']
    });
  });

  syncOpenedCards();

  if (resetButton) {
    resetButton.addEventListener('click', function () {
      logOracle('resetButton:click', {
        shouldShuffleOnReset: shouldShuffleOnReset,
        openedCards: Array.from(openedCards).map(getCardDebugState)
      });
      closeOverlay();
      resetAllCards();

      if (shouldShuffleOnReset) {
        shuffleCards();
      }
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      logOracle('closeButton:click', {
        activeCard: getCardDebugState(activeCard)
      });
      closeOverlay(false);
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
        logOracle('overlayBackground:click', {
          activeCard: getCardDebugState(activeCard)
        });
        closeOverlay(false);
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && overlay && overlay.classList.contains('is-visible')) {
      logOracle('escape:keydown', {
        activeCard: getCardDebugState(activeCard)
      });
      closeOverlay(false);
    }
  });
});
